<template>
  <div v-if="showPaymentCard">
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__1">Payment Cards</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top"> </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__2">Payment Cards - Payment Card Offer Details</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top"> </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Application Type :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{application_type}}
       
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Card Network :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{card_network}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Primary Card Level :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{primary_card_level}}
        
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Secondary Card Level(s) :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{secondary_card_level}}
       
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Reward Program :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
<span v-if="reward_program == 1">Yes</span>
<span v-else>No</span>
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Reward Program Emphasis:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{reward_program_emphasis}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Reward Program Rate:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{reward_program_rate}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Reloadable:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{reloadable}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__2">Payment Cards - Regular Pricing</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top"> </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 1 Purchase Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{tier_1_purchase_regular_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 2 Purchase Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{tier_2_purchase_regular_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 3 Purchase Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{tier_3_purchase_regular_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Purchase Regular APR (%) Detail :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{purchase_regular_apr_detail}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom"
        >Perchase Regular Rate Type:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{perchase_regular_rate_type}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 1 Balance Transfer Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{tier_1_balance_transfer_regular_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 2 Balance Transfer Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{tier_2_balance_transfer_regular_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 3 Balance Transfer Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{tier_3_balance_transfer_regular_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Regular APR (%) Detail :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{balance_transfer_regular_apr_detail}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Regular Rate Type :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{balance_transfer_regular_rate_type}}
       
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 1 Cash Advance Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{tier_1_cash_advance_regular_apr}}
     
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 2 Cash Advance Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{tier_2_cash_advance_regular_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 3 Cash Advance Regular APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{tier_3_cash_advance_regular_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Regular APR (%) Details:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{cash_advance_regular_apr_details}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Regular Rate Type:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{cash_advance_regular_rate_type}}
        
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__2">Payment Cards - Pricing: Fees & Limit:</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top"> </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 1 Annual Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{tier_1_annual_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 2 Annual Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{tier_2_annual_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 3 Annual Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{tier_3_annual_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Annual Fee ($) Details :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
   {{annual_fee_details}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 1 Late Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{tier_1_late_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 2 Late Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{tier_2_late_fee}}
      
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 3 Late Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{tier_3_late_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Late Fee ($) Details :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
     {{late_fee_details}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 1 Overlimit Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{tier_1_overlimit_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 2 Overlimit Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{tier_2_overlimit_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Tier 3 Overlimit Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{tier_3_overlimit_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Overlimit Fee ($) Details :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{overlimit_fee_details}}
        
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Usage Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{balance_transfer_usage_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Minimum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{balance_transfer_minimum_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Maximun Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{balance_transfer_maximun_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Usage Fee (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{cash_advance_usage_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Minimum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{cash_advance_minimum_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Maximum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{cash_advance_maximum_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Minimum Card Limit ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{minimum_card_limit}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Maximum Card Limit ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{maximum_card_limit}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        <span id="banking__2">Payment Cards - Introductory Pricing</span>
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top"> </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Purchase Introductory APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{purchase_introductory_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Purchase Introductory Period (Months):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{purchase_introductory_period_months}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Introductory APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{balance_transfer_introductory_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Introductory Period (Months):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{balance_transfer_introductory_period_months}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Introductory Usage Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{balance_transfer_introductory_usage_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Introductory Minimum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{balance_transfer_introductory_minimum_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Introductory Maximum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
      {{balance_transfer_introductory_maximum_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Introductory Fee Period (Months):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{balance_transfer_introductory_fee_period_months}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Balance Transfer Introductory Fee Details :
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{balance_transfer_introductory_fee_details}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Introductory APR (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{cash_advance_introductory_apr}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Introductory Period (Months):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{cash_advance_introductory_period_months}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Introductory Usage Fee (%):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{cash_advance_introductory_usage_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Introductory Minimum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{cash_advance_introductory_minimum_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Introductory Maximum Fee ($):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{cash_advance_introductory_maximum_fee}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Introductory Fee Period (Months):
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
        {{cash_advance_introductory_fee_period_months}}
      </v-col>
    </v-row>
    <v-row id="product__rowpadding">
      <v-col :cols="4" class="label-field text-left no-right no-bottom">
        Cash Advance Introductory Fee Details:
      </v-col>
      <v-col :cols="6" class="text-left no-left no-bottom no-top">
       {{cash_advance_introductory_fee_details}}
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  name: "PaymentCard",
  data: () => ({
    items: ["Foo", "Bar", "Fizz", "Buzz"],
  }),
  props: ["showPaymentCard"],
  computed: {
    ...mapGetters({
      application_types: "ProductData/getAllApplicationTypes",
      rate_type_options: "ProductData/getPaymentRateTypes",
      all_card_network: "ProductData/getAllCardTypes",
      all_primary_card_level: "ProductData/getAllCardLevels",
      all_secondary_card_level: "ProductData/getAllCardLevels",
      all_reward_program_emphasis: "ProductData/getAllRewardTypes",
    }),
    tier_1_cash_advance_regular_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier1CashAdvanceRegularApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardTier1CashAdvanceRegularApr",
          o
        );
      },
    },
    tier_2_cash_advance_regular_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier2CashAdvanceRegularApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardTier2CashAdvanceRegularApr",
          o
        );
      },
    },
    tier_3_cash_advance_regular_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier3CashAdvanceRegularApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardTier3CashAdvanceRegularApr",
          o
        );
      },
    },
    cash_advance_regular_apr_details: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceRegularAprDetails"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceRegularAprDetails",
          o
        );
      },
    },
    cash_advance_regular_rate_type: {
      get: function () {
         if(this.$store.getters['ProductData/getPaymentCardCashAdvanceRegularRateType']!= ''){
            return this.rate_type_options.find(cash_advance_regular_rate_type=>cash_advance_regular_rate_type.value===this.$store.getters['ProductData/getPaymentCardCashAdvanceRegularRateType']).text  
          }else{
            return ''
          }
       
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceRegularRateType",
          o
        );
      },
    },
    application_type: {
      get: function () {
         if(this.$store.getters['ProductData/getPaymentCardApplicationType']!= ''){
            return this.rate_type_options.find(application_type=>application_type.value===this.$store.getters['ProductData/getPaymentCardApplicationType']).text  
          }else{
            return ''
          }
       
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardApplicationType", o);
      },
    },
    card_network: {
      get: function () {
        return this.$store.getters["ProductData/getPaymentCardCardNetwork"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardCardNetwork", o);
      },
    },
    primary_card_level: {
      get: function () {
        if(this.$store.getters["ProductData/getTargetMarket"].length>0){
          const newar = new Array()
          let name_el = ''
          for (let resp in this.$store.getters["ProductData/getPaymentCardPrimaryCardLevel"]){
            name_el = this.all_card_network.find(primary_card_level =>primary_card_level.value === this.$store.getters["ProductData/getPaymentCardPrimaryCardLevel"][resp]).text
            newar.push(name_el) 
          }
             return newar.join();

        }else{
          return ""
        }
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardPrimaryCardLevel", o);
      },
    },
    secondary_card_level: {
      get: function () {
        if(this.$store.getters["ProductData/getTargetMarket"].length>0){
          const newar = new Array()
          let name_el = ''
          for (let resp in this.$store.getters["ProductData/getPaymentCardSecondaryCardLevel"]){
            name_el = this.all_card_network.find(secondary_card_level =>secondary_card_level.value === this.$store.getters["ProductData/getPaymentCardSecondaryCardLevel"][resp]).text
            newar.push(name_el) 
          }
             return newar.join();

        }else{
          return ""
        }
        
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardSecondaryCardLevel", o);
      },
    },
    reward_program: {
      get: function () {
        return this.$store.getters["ProductData/getPaymentCardRewardProgram"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardRewardProgram", o);
      },
    },
    reward_program_emphasis: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardRewardProgramEmphasis"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardRewardProgramEmphasis",
          o
        );
      },
    },
    reward_program_rate: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardRewardProgramRate"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardRewardProgramRate", o);
      },
    },
    reloadable: {
      get: function () {
        return this.$store.getters["ProductData/getPaymentCardReloadable"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardReloadable", o);
      },
    },
    tier_1_purchase_regular_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier1PurchaseRegularApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardTier1PurchaseRegularApr",
          o
        );
      },
    },
    tier_2_purchase_regular_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier2PurchaseRegularApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardTier2PurchaseRegularApr",
          o
        );
      },
    },
    tier_3_purchase_regular_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier3PurchaseRegularApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardTier3PurchaseRegularApr",
          o
        );
      },
    },
    purchase_regular_apr_detail: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardPurchaseRegularAprDetail"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardPurchaseRegularAprDetail",
          o
        );
      },
    },
    perchase_regular_rate_type: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardPerchaseRegularRateType"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardPerchaseRegularRateType",
          o
        );
      },
    },
    tier_1_balance_transfer_regular_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier1BalanceTransferRegularApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardTier1BalanceTransferRegularApr",
          o
        );
      },
    },
    tier_2_balance_transfer_regular_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier2BalanceTransferRegularApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardTier2BalanceTransferRegularApr",
          o
        );
      },
    },
    tier_3_balance_transfer_regular_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier3BalanceTransferRegularApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardTier3BalanceTransferRegularApr",
          o
        );
      },
    },
    balance_transfer_regular_rate_type: {
      get: function () {
         if(this.$store.getters['ProductData/getPaymentCardBalanceTransferRegularRateType']!= ''){
            return this.rate_type_options.find(balance_transfer_regular_rate_type=>balance_transfer_regular_rate_type.value===this.$store.getters['ProductData/getPaymentCardBalanceTransferRegularRateType']).text  
          }else{
            return ''
          }
        
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferRegularRateType",
          o
        );
      },
    },
    balance_transfer_regular_apr_detail: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferRegularAprDetail"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferRegularAprDetail",
          o
        );
      },
    },
    tier_1_annual_fee: {
      get: function () {
        return this.$store.getters["ProductData/getPaymentCardTier1AnnualFee"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardTier1AnnualFee", o);
      },
    },
    tier_2_annual_fee: {
      get: function () {
        return this.$store.getters["ProductData/getPaymentCardTier2AnnualFee"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardTier2AnnualFee", o);
      },
    },
    tier_3_annual_fee: {
      get: function () {
        return this.$store.getters["ProductData/getPaymentCardTier3AnnualFee"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardTier3AnnualFee", o);
      },
    },
    annual_fee_details: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardAnnualFeeDetails"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardAnnualFeeDetails", o);
      },
    },
    tier_1_late_fee: {
      get: function () {
        return this.$store.getters["ProductData/getPaymentCardTier1LateFee"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardTier1LateFee", o);
      },
    },
    tier_2_late_fee: {
      get: function () {
        return this.$store.getters["ProductData/getPaymentCardTier2LateFee"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardTier2LateFee", o);
      },
    },
    tier_3_late_fee: {
      get: function () {
        return this.$store.getters["ProductData/getPaymentCardTier3LateFee"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardTier3LateFee", o);
      },
    },
    late_fee_details: {
      get: function () {
        return this.$store.getters["ProductData/getPaymentCardLateFeeDetails"];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardLateFeeDetails", o);
      },
    },
    tier_1_overlimit_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier1OverlimitFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardTier1OverlimitFee", o);
      },
    },
    tier_2_overlimit_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier2OverlimitFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardTier2OverlimitFee", o);
      },
    },
    tier_3_overlimit_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardTier3OverlimitFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardTier3OverlimitFee", o);
      },
    },
    overlimit_fee_details: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardOverlimitFeeDetails"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardOverlimitFeeDetails",
          o
        );
      },
    },
    balance_transfer_usage_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferUsageFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferUsageFee",
          o
        );
      },
    },
    balance_transfer_minimum_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferMinimumFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferMinimumFee",
          o
        );
      },
    },
    balance_transfer_maximun_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferMaximunFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferMaximunFee",
          o
        );
      },
    },
    cash_advance_usage_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceUsageFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceUsageFee",
          o
        );
      },
    },
    cash_advance_minimum_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceMinimumFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceMinimumFee",
          o
        );
      },
    },
    cash_advance_maximum_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceMaximumFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceMaximumFee",
          o
        );
      },
    },
    minimum_card_limit: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardMinimumCardLimit"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardMinimumCardLimit", o);
      },
    },
    maximum_card_limit: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardMaximumCardLimit"
        ];
      },
      set: function (o) {
        this.$store.dispatch("ProductData/setPaymentCardMaximumCardLimit", o);
      },
    },
    purchase_introductory_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardPurchaseIntroductoryApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardPurchaseIntroductoryApr",
          o
        );
      },
    },
    purchase_introductory_period_months: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardPurchaseIntroductoryPeriodMonths"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardPurchaseIntroductoryPeriodMonths",
          o
        );
      },
    },
    balance_transfer_introductory_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferIntroductoryApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferIntroductoryApr",
          o
        );
      },
    },
    balance_transfer_introductory_period_months: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferIntroductoryPeriodMonths"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferIntroductoryPeriodMonths",
          o
        );
      },
    },
    balance_transfer_introductory_usage_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferIntroductoryUsageFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferIntroductoryUsageFee",
          o
        );
      },
    },
    balance_transfer_introductory_minimum_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferIntroductoryMinimumFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferIntroductoryMinimumFee",
          o
        );
      },
    },
    balance_transfer_introductory_maximum_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferIntroductoryMaximumFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferIntroductoryMaximumFee",
          o
        );
      },
    },
    balance_transfer_introductory_fee_period_months: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferIntroductoryFeePeriodMonths"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferIntroductoryFeePeriodMonths",
          o
        );
      },
    },
    balance_transfer_introductory_fee_details: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardBalanceTransferIntroductoryFeeDetails"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardBalanceTransferIntroductoryFeeDetails",
          o
        );
      },
    },
    cash_advance_introductory_apr: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceIntroductoryApr"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceIntroductoryApr",
          o
        );
      },
    },
    cash_advance_introductory_period_months: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceIntroductoryPeriodMonths"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceIntroductoryPeriodMonths",
          o
        );
      },
    },
    cash_advance_introductory_usage_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceIntroductoryUsageFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceIntroductoryUsageFee",
          o
        );
      },
    },
    cash_advance_introductory_minimum_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceIntroductoryMinimumFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceIntroductoryMinimumFee",
          o
        );
      },
    },
    cash_advance_introductory_maximum_fee: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceIntroductoryMaximumFee"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceIntroductoryMaximumFee",
          o
        );
      },
    },
    cash_advance_introductory_fee_period_months: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceIntroductoryFeePeriodMonths"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceIntroductoryFeePeriodMonths",
          o
        );
      },
    },
    cash_advance_introductory_fee_details: {
      get: function () {
        return this.$store.getters[
          "ProductData/getPaymentCardCashAdvanceIntroductoryFeeDetails"
        ];
      },
      set: function (o) {
        this.$store.dispatch(
          "ProductData/setPaymentCardCashAdvanceIntroductoryFeeDetails",
          o
        );
      },
    },
  },
};
</script>

<style lang="sass" scoped>
@import './../../assets/sass/product/banking'
</style>